/* eslint-disable prettier/prettier */
export const NC_UPDATE_VALUE = 'NC_UPDATE_VALUE';
export const NC_RESET_CLAIM = 'NC_RESET_CLAIM';
export const NC_INIT_VALUE = 'NC_INIT_VALUE';
export const CURRENCY_UPDATE_VALUE = 'CURRENCY_UPDATE_VALUE';
export const CURRENCY_CHANGE_OBJ = 'CURRENCY_CHANGE_OBJ';
